import { render, staticRenderFns } from "./product-reviews.vue?vue&type=template&id=ed6b50a4&"
import script from "./product-reviews.vue?vue&type=script&lang=js&"
export * from "./product-reviews.vue?vue&type=script&lang=js&"
import style0 from "./product-reviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed6b50a4')) {
      api.createRecord('ed6b50a4', component.options)
    } else {
      api.reload('ed6b50a4', component.options)
    }
    module.hot.accept("./product-reviews.vue?vue&type=template&id=ed6b50a4&", function () {
      api.rerender('ed6b50a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-reviews.vue"
export default component.exports